.RDIContainer
    width: 100%
    display: flex
    flex-direction: column
    .RDITitle
        font-size: 18px
        font-weight: 700

    .RDIWarning
        color: rgb($globalErrorBackground)
